import { useEffect, useState } from "react";
import { useLoader } from "../../context/LoaderContext";
import axiosUserInstance from "../../axiosUserInstance";
import AdminLayout from "./AdminLayout";
import { Card, Row, Col } from "react-bootstrap";
import "../../Assets/css/AdminDashboard.css";

const AdminDashboard = () => {
  const { setLoading } = useLoader();
  const [summary, setSummary] = useState({
    totalFreeUsers: 0,
    totalPaidUsers: 0,
    totalPaidMonthlyUsers: 0,
    totalPaidYearlyUsers: 0,
    totalLiveLinks: 0,
    totalDisabledLinks: 0,
    totalDeletedAccounts: 0,
  });

  useEffect(() => {
    fetchDashboardSummary();
  }, []);

  const fetchDashboardSummary = async () => {
    try {
      setLoading(true);
      const response = await axiosUserInstance.get(`/user/dashboard-summary`);
      if (response?.status === 200) {
        setSummary(response.data.data);
      }
    } catch (err) {
      console.error("Error fetching dashboard-summary:", err);
    } finally {
      setLoading(false);
    }
  };

  const cards = [
    { title: "Total Free Users", value: summary.totalFreeUsers, color: "primary" },
    { title: "Total Paid Users", value: summary.totalPaidUsers, color: "success" },
    { title: "Total Monthly Users", value: summary.totalPaidMonthlyUsers, color: "secondary" },
    { title: "Total Yearly Users", value: summary.totalPaidYearlyUsers, color: "dark" },
    { title: "Total Live Links", value: summary.totalLiveLinks, color: "info" },
    { title: "Total Disabled Links", value: summary.totalDisabledLinks, color: "warning" },
    { title: "Total Deleted Accounts", value: summary.totalDeletedAccounts, color: "danger" },
  ];

  return (
    <AdminLayout>
      <div className="container mt-4">
        <h2 className="mb-4">Dashboard</h2>

        <Row className="g-3">
          {cards.map((card, idx) => (
            <Col key={idx} xs={12} sm={6} md={4} lg={3}>
              <Card className={`dashboard-card border-${card.color} h-100`}>
                <Card.Body>
                  <Card.Title>{card.title}</Card.Title>
                  <Card.Text className="dashboard-value">{card.value}</Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </div>
    </AdminLayout>
  );
};

export default AdminDashboard;
